<template>
  <b-modal
    :active.sync="active_"
    has-modal-card
    class="rate-form-modal"
    @close="close"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Create Rate</p>
      </header>
      <section class="modal-card-body">
        <base-combobox
          :value="rate ? rate.category : ''"
					:service="$options.rateService"
					fetch-func="listCategoryTags"
          :fetch-params="{ firm_id: contract ? contract.contractee_firm_id : undefined }"
					fetch-on-init
					:create-service="$options.tagService"
					create-func="store"
					:create-params="{ firm_id: contract ? contract.contractee_firm_id : undefined, type: '[RATE][CATEGORY]' }"
					label="Category"
					allow-new
					@select="option => form.category_tag_id = option.id"
					@add-new="option => form.category_tag_id = option.id"
				/>
        <b-field label="Code">
          <b-input v-model="form.code" :disabled="rate"></b-input>
        </b-field>
        <b-field label="Description">
          <b-input v-model="form.description" type="textarea"></b-input>
        </b-field>
        <b-field label="UOM">
          <b-input v-model="form.uom"></b-input>
        </b-field>
        <b-field label="Rate" v-if="contract">
          <b-numberinput v-model="form.rate"></b-numberinput>
        </b-field>
        <!-- <base-select
          :service="$options.rateService"
          fetch-func="listCategoryTags"
          label="Category"
          :value.sync="form.category_tag_id"
          @change="(v) => (form.category = v ? v.name : '')"
        /> -->
      </section>
      <footer class="modal-card-foot">
        <b-button @click="close">Cancel</b-button>
        <b-button :loading="loading" @click.prevent="submitRate">
          Save
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import BaseCombobox from "@/components/partials/BaseCombobox";
import BaseSelect from "@/components/partials/BaseSelect";
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
import { TagService } from "@/services/tag.service";

export default {
  rateService: OrderOperationClaimServiceService,
  tagService: TagService,
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    rate: {
      type: Object,
    },
    firm: {
      type: Object,
    },
    contract: {
      type: Object,
    },
    contractTypeTagId: {
      type: [String, Number],
    },
  },
  components: {
    BaseCombobox,
    BaseSelect,
  },
  data: () => ({
    active_: false,
    form: {
      code: "",
      description: "",
      rate: 0,
      uom: "",
      category: "",
      category_tag_id: null,
    },
    loading: false,
  }),
  mounted() {
    this.populateForm();
  },
  watch: {
    active(active) {
      this.active_ = active;
    },
    active_(active) {
      this.$emit("update:active", active);
    },
    rate() {
      this.populateForm();
    }
  },
  methods: {
    populateForm() {
      if (this.rate) {
        this.form = {
          code: this.rate.code,
          description: this.rate.description || "",
          rate: this.rate.rate ? parseFloat(this.rate.rate) : 0,
          uom: this.rate.uom || "",
          category: this.rate.category || "",
          category_tag_id: this.rate.categoryTags.length ? this.rate.categoryTags[0].id : null,
        };
      }
    },
    clearForm() {
      this.form = {
        code: "",
        description: "",
        rate: 0,
        category: "",
        uom: "",
        category_tag_id: null,
      };
    },
    close() {
      this.clearForm();
      this.$emit("close");
      this.active_ = false;
    },
    transformData() {
      return {
        ...this.form,
        firm_id: this.firm ? this.firm.id : undefined,
        contract_id: this.contract ? this.contract.id : undefined,
        category_tag_id: this.form.category_tag_id || undefined,
        contract_type_tag_id: this.contractTypeTagId || undefined,
        rate: this.contract ? this.form.rate : undefined,
      };
    },
    async submitRate() {
      try {
        this.loading = true;
        await this.$options.rateService.create(this.transformData());
        this.$buefy.toast.open({
          message: "Rate has been created.",
          type: "is-info",
          position: "is-top-right",
        });
        this.$emit("submit");
        this.close();
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Rate/RateFormModal.vue